import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Table, Nav, Row, Col } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { toast } from "react-toastify";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";

const PaypapSetting = ({ activeTab, setActiveTab }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getPaypalData",
            user_key: sessionStorage.getItem("pk_user_key"),
        });
        const output = response.data;

        if (output) {
            setRows(output);
        }
    };

    const { handleSubmit, values, errors, touched, handleChange, handleBlur, setTouched, resetForm, setFieldValue } = useFormik({
        initialValues: {
            pk_pp_key: "",
            business_id: "",
        },
        validationSchema: Yup.object().shape({
            business_id: Yup.string()
                .required("Paypal ID required.")
                .test("unique-id", "Paypal ID Invalid", async function (value) {
                    if (!value) return true;
                    return await checkBusinessID(value);
                }),
        }),
        onSubmit: async (formValues) => {
            toast.dismiss();
            setIsSubmitting(true);

            try {
                const response = await axios.post(
                    `${BASE_URL}API/apicall`,
                    {
                        security_key,
                        mode: activeTab == "paypal-add" ? "addPaypalData" : "updatePaypalData",
                        ...formValues,
                        user_key: sessionStorage.getItem("pk_user_key"),
                    },
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const output = response.data;
                if (output == 1) {
                    if (activeTab == "paypal-add") {
                        fetchData();
                        toast.success("Added successfully!", {
                            autoClose: 3000,
                        });
                    } else {
                        fetchData();
                        toast.success("Updated successfully!", {
                            autoClose: 3000,
                        });
                    }
                    fetchData();
                    setActiveTab("paypal-list");
                } else {
                    toast.error("Oops! Something went wrong.", {
                        autoClose: 3000,
                    });
                }
            } catch (error) {
                toast.error("Error: " + error.message);
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    async function checkBusinessID(ID) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "validateBusinessID",
            business_id: ID,
        });

        const output = response.data;

        return output === 200 ? true : false;
    }

    const handleEditClick = (selRow) => {
        setFieldValue("pk_pp_key", selRow.pk_pp_key);
        setFieldValue("business_id", selRow.business_id);
        setActiveTab("paypal-edit");
    };

    const handleCancel = () => {
        resetForm("");
        setActiveTab("paypal-list");
    };

    const handleProceed = (business_id) => {
        // Open a new window with custom settings and give it a name
        // const newWindow = window.open("", "paypalWindow", "width=600,height=700,toolbar=0,location=0,menubar=0,scrollbars=1");
        const newWindow = window.open("", "paypalWindow", "toolbar=0,location=0,menubar=0,scrollbars=1");

        if (newWindow) {
            // Create a form dynamically
            const form = document.createElement("form");
            form.action = "https://www.sandbox.paypal.com/cgi-bin/webscr";
            form.method = "POST";
            form.target = "paypalWindow"; // Use the new window's name as the target

            // Add form fields
            const fields = {
                cmd: "_xclick",
                business: business_id,
                currency_code: "USD",
                amount: 1,
                item_name: "Test Payment",
                return: BASE_URL,
                cancel_return: BASE_URL,
                notify_url: BASE_URL + "API/pay_notify.php",
                // image_url: BASE_URL + "API/logo.png",
                image_url: BASE_URL + "API/paperboy_paypal_logo.png",

                custom: JSON.stringify({
                    type: 3,
                    payer_user_key: sessionStorage.getItem("pk_user_key"),
                    receiver_user_key: sessionStorage.getItem("pk_user_key"),
                }),
            };

            // Append fields to the form
            Object.keys(fields).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = fields[key];
                form.appendChild(input);
            });

            // Append the form to the body, submit it to the new window, and then remove it
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        } else {
            toast.error("Popup blocked. Please allow popups for this site.");
        }
    };

    return (
        <>
            {activeTab === "paypal-list" && (
                <div>
                    {rows.length == 0 && (
                        <div className="text-end my-1">
                            <button className="btn btn-sm btn-dark" onClick={() => setActiveTab("paypal-add")}>
                                Add
                            </button>
                        </div>
                    )}
                    <div className="table-responsive">
                        <Table striped bordered hover className="table-responsive-scroll">
                            <thead className="thead-dark">
                                <tr>
                                    <th>S.No</th>
                                    <th>Paypal ID</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.length == 0 && (
                                    <tr>
                                        <td colSpan={3}>
                                            <h6 className="text-center">No data available</h6>
                                        </td>
                                    </tr>
                                )}
                                {rows.map((row, index) => (
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{row.business_id}</td>
                                        <td>
                                            <Tooltip title="Edit">
                                                <Button variant="outline-dark" size="sm" onClick={() => handleEditClick(row)} className="me-2">
                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                </Button>
                                            </Tooltip>

                                            <Tooltip title="Test Pay Your Account">
                                                <Button variant="outline-dark" size="sm" onClick={() => handleProceed(row.business_id)}>
                                                    {/* <i class="fa-brands fa-cc-paypal"></i> */}
                                                    <i class="fa-brands fa-paypal"></i>
                                                </Button>
                                            </Tooltip>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )}

            {activeTab === "paypal-add" && (
                <div className="bg-white p-4">
                    <h4>Add Paypal Credential</h4>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Paypal ID <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="business_id"
                                value={values.business_id}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Paypal ID"
                            />
                            {errors.business_id && touched.business_id && <p className="text-danger">{errors.business_id}</p>}
                        </Form.Group>

                        <Button type="submit" className="btn btn-dark mt-3" disabled={isSubmitting}>
                            Add
                            {isSubmitting && <LinearProgress />}
                        </Button>
                        <Button type="button" className="btn btn-outline-secondary ms-2 mt-3" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Form>
                </div>
            )}

            {activeTab === "paypal-edit" && (
                <div className="bg-white p-4">
                    <h4>Edit Paypal Credential</h4>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Paypal ID <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="business_id"
                                value={values.business_id}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Paypal ID"
                            />
                            {errors.business_id && touched.business_id && <p className="text-danger">{errors.business_id}</p>}
                        </Form.Group>

                        <Button type="submit" className="btn btn-dark mt-3" disabled={isSubmitting}>
                            Save
                            {isSubmitting && <LinearProgress />}
                        </Button>
                        <Button type="button" className="btn btn-outline-secondary ms-2 mt-3" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Form>
                </div>
            )}
        </>
    );
};

export default PaypapSetting;
